import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, RoutingConfig } from '@spartacus/core';
import { CmsPageGuard, FormErrorsModule, PageLayoutComponent } from '@spartacus/storefront';
import { KnBrCustomerContextGuard } from 'src/shared/guards/kn-br-customer-context.guard';
import { KnBrOrderImportComponent } from './kn-br-order-import.component';

@NgModule({
  declarations: [KnBrOrderImportComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormErrorsModule,
    FileUploadModule,
    BrowserAnimationsModule,
    RouterModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrOrderImportComponent: {
          component: () => import('./kn-br-order-import.component').then((c) => c.KnBrOrderImportComponent),
        },
      },
    } as CmsConfig),
    RouterModule.forChild([
      {
        data: { pageLabel: '/order-import', cxRoute: 'orderImport' },
        path: null,
        canActivate: [AuthGuard, CmsPageGuard, KnBrCustomerContextGuard],
        component: PageLayoutComponent,
      },
    ]),
    ConfigModule.withConfig({
      routing: {
        routes: {
          orderImport: {
            paths: ['order-import'],
          },
        },
      },
    } as RoutingConfig),
  ],
})
export class KnBrOrderImportModule { }
